module.exports = __webpack_public_path__ + "img/xlfd.199397a5.png";